export default (context, html) => html`
  <div id="riq-video-container">
    <video id="riq-video" @ended="${(e) => context.handleClose(e)}" @fullscreenchange="${(e) => context.handleFullscreenchange(e)}" src="${require('./videos/what_is_reading_iq-v3.mp4')}" controls controlsList="nodownload"></video>
    <div id="svg-wrapper" @click="${(e) => context.handleClose(e)}">
      <span class="close-button"></span>
    </div>
  </div>
`;
